<template>
  <div>
    <h4 class="my-3">
      {{$t('message.manageAcceptedModal')}}
    </h4>

    <b-button
      variant="success"
      class="float-end ms-3"
      @click="onSubmit"
      :disabled="db"
    >
      {{$t('modal.button.accept')}}
    </b-button>

    <b-button
      variant="warning"
      class="float-end"
      @click="onClose"
    >
      {{$t('modal.button.back')}}
    </b-button>
  </div>
</template>

<script>
  import {update} from '../../../../api/endpoints/managerManageIncomDeliveries'

  export default {
    name: "Manager-AcceptedModal",
    props: {
      id: {
        type: Number,
        required: true
      }
    },
    data() {
      return {
        db: false,
      }
    },
    methods: {
      onClose() {
        this.$emit('onClose');
      },
      onSubmit() {
        this.db = true;
        setTimeout(() => {
          this.db = false;
        }, 700)
        update({
          id: this.id,
          status: "accepted"
        }).then( () => {
          this.onClose();
        })
      }
    }
  }
</script>